import { useExperimentFlag } from './useExperimentFlag';

export function useFavoritesEnabled(): boolean {
    return String(useExperimentFlag('favorites_enabled')) === '1';
}
